export default __webpack_public_path__ + "images/057be4b35300d10afd030c17076bb791-health.webp";